import ClassicEditor from "@vvg/forum/js/ckeditor/ckeditor";
window.ClassicEditor = ClassicEditor;
